import classNames from 'classnames';
import { observer } from 'mobx-react';
import { store } from 'Models/Store';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router';
import HandleEvents from 'Util/HandleEvents';
import { PageBreadcrumbs } from 'Views/Components/Breadcrumbs/PageBreadcrumbs';
import AccessIntelSecuredPage from 'Views/Components/Security/AccessIntelSecuredPage';
import { CreditProviderItemDetail } from 'Views/Components/Settings/CreditProviderItemDetail';
import { CreditProviderList } from 'Views/Components/Settings/CreditProviderList';
import { AppSettingStoreContext, appSettingStore } from 'Views/Components/Settings/SettingStores/AppSettingPageStore';
import UploadTerms from 'Views/Components/Settings/UploadTerms';

export interface AppSettingsPageProps extends RouteComponentProps {}

const AppSettingsPage = observer((props: AppSettingsPageProps) => {
	const { location, match } = props;
	const { path } = match;

	return (
		<AccessIntelSecuredPage routeComponentProps={props} groups={['Super Administrators', 'SUPER_USER']}>
			<div className="body-content app-settings-page">
				<div className="invisible-page-wrap">
					<div className="top-container">
						<PageBreadcrumbs
							tags={
								[
									{ label: 'Settings' },
								]
							}
						/>
					</div>
					<div className="tab-selector-wrap">
						<button
							className={classNames(
								"tab-selector",
								"terms-and-conditions",
								{ active: location.pathname.includes('terms-and-conditions') }
							)}
							{...HandleEvents(() => {
								store.routerHistory.push(`/hub/settings/terms-and-conditions`);
							})}
						>
							Terms & conditions
						</button>
						<button
							className={classNames(
								"tab-selector",
								"credit-providers",
								{ active: location.pathname.includes('credit-providers') }
							)}
							{...HandleEvents(() => {
								store.routerHistory.push(`/hub/settings/credit-providers`);
							})}
						>
							Credit Providers
						</button>
					</div>
					<div className="white-box">
						<AppSettingStoreContext.Provider value={appSettingStore}>
							<Switch>
								<Route path={`${path}/terms-and-conditions`}>
									<UploadTerms />
								</Route>
								<Route path={`${path}/credit-providers/add`}>
									<CreditProviderItemDetail isNew={true} />
								</Route>
								<Route path={`${path}/credit-providers/:providerId`}>
									<CreditProviderItemDetail />
								</Route>
								<Route path={`${path}/credit-providers`}>
									<CreditProviderList />
								</Route>
								<Redirect from='/hub/settings' to={`${path}/terms-and-conditions`} />
							</Switch>
						</AppSettingStoreContext.Provider>
					</div>
				</div>
			</div>
		</AccessIntelSecuredPage>
	);
});

export default AppSettingsPage;
